import React from 'react';

import useTimeFormat from 'bringg-web/hooks/use-time-format';
import { Date } from '../../../../../components';
import { DetailedCellProps } from '../hooks/use-columns';

const TimeCell = ({ value }: DetailedCellProps) => {
	const timeFormat = useTimeFormat();

	return <Date format={timeFormat} date={value} />;
};

export default TimeCell;
